// ** React imports
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'

// ** MUI imports
import { Chip, FormControl, makeStyles, Input } from '@material-ui/core'
import { Typography } from '@mui/material'

const styledMultyInput = makeStyles(theme => ({
  formControlRoot: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    width: '100%',
    flexWrap: 'wrap',
    flexDirection: 'row',
    border: '1px solid lightgray',
    boxShadow: '0.5px 0.5px 2px 0px #f0f0f0',
    '&:hover, &:focus, &.ps--clicking': {
      boxShadow: '1px 0.5px 2px 0px #f0f0f0'
    },
    padding: '0.25rem',
    borderRadius: '8px'
  }
}))

interface MultipleValuesInputProps {
  label: string
  isInputHidden?: boolean
  setValues: (value: string) => void
  values: string
}

const MultipleValuesInput: React.FC<MultipleValuesInputProps> = ({
  label,
  isInputHidden = false,
  setValues,
  values
}) => {
  const classes = styledMultyInput()

  const [currValue, setCurrValue] = useState('')

  const handleKeyUp = (event: React.KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    // if ((event.code == 'Comma' || event.code == 'Space' || event.code == 'Enter') && Boolean(currValue?.trim())) {
    //   setValues(oldState => [...oldState, currValue])
    //   setCurrValue('')
    //   return
    // }
    // if (event.code == 'Backspace' && Boolean(values?.length)) {
    //   setValues(values.slice(0, values.length - 1))
    //   return
    // }
  }

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    if (event.target.value !== ' ' && event.target.value !== ',') {
      setCurrValue(event.target.value.trim())
      setValues(event.target.value.trim())
    }
  }

  const handleDelete = (index: number) => {
    // const modifiedValues = [...values]
    // modifiedValues?.splice(index, 1)
    // setValues(modifiedValues)
  }

  return (
    <div className='w-full'>
      <Typography
        variant='body2'
        sx={{
          fontWeight: 500,
          fontSize: 12,
          whiteSpace: 'nowrap'
        }}
      >
        {label}
      </Typography>
      <FormControl classes={{ root: classes.formControlRoot }}>
        {/* <div className='flex flex-wrap w-full h-full gap-1'>
          {values?.map((item: string, index: number) => (
            <Chip
              key={`${index}_${item}`}
              style={{ borderRadius: '6px', border: '1px solid #F0F0F0', background: '#F5F5F5' }}
              size='medium'
              onDelete={() => handleDelete(index)}
              label={item}
            />
          ))}
        </div> */}
        {!Boolean(isInputHidden) ? (
          <Input
            value={currValue}
            autoFocus
            onChange={handleChange}
            onKeyDown={handleKeyUp}
            color={'primary'}
            fullWidth
            disableUnderline
            style={{ paddingLeft: '8px' }}
          />
        ) : (
          <></>
        )}
      </FormControl>
    </div>
  )
}

export default MultipleValuesInput
